// ------------------------------------------------------------------------------
// name: pathname
// author: mudas
// created: 2024/12/20
// ------------------------------------------------------------------------------

export enum MANAGER_ROUTER_PATHNAME {
  WORKFLOW = 'workflow',
  ARTIST_HOME = 'artist-home',
  TIAN_GONG = 'tiangong',
  TASK_MANAGEMENT = 'task-management',
  USER_MANAGEMENT = 'user-management',
  CERTIFICATE_MANAGEMENT = 'cetificate-management',
  BIDDING_MANAGEMENT = 'bidding-management',
  HANDLING_BIDDING_TASK = 'handling-bidding-task',
  BIDDING_TASK_DETAIL = 'bidding-task-detail',
  ARTIST_MANAGEMENT = 'artist-management',
  FUNDS_MANAGEMENT = 'funds-management',

  // 数据报表
  DATA_REPORT = 'data-report',

  // 合同管理
  CONTRACT_MANAGEMENT = 'contract-management',

  // 云桌面管理
  CLOUD_DESKTOP = 'cloud-desktop',

  // 运营推荐工具
  RECOMMENDED_TOOLS = 'recommended-tools',

  // 运营推荐创作者详情
  RECOMMENDED_ARTIST_DETAIL = 'recommended-artist-detail',
}
